import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { throwIfAlreadyLoaded } from './module-import.guard';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppConfigService } from './services/app-config.service';
import { JwtInterceptor } from './interceptors/jwt-interceptor.service';
import { ErrorInterceptor } from './interceptors/error-interceptor.service';
import { LocalizationService } from '../shared/services/localization/localization.service';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/');
}

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    AppConfigService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {
  constructor(
    @Optional() @SkipSelf() parentModule: CoreModule,
    translate: TranslateService,
    localization: LocalizationService,
  ) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');

    translate.addLangs(['fr', 'en']);
    translate.setDefaultLang('fr');
    localization.loadFromStorage();

    const browserLang = localization.getLang();
    translate.use(RegExp(/fr|en/).exec(browserLang) ? browserLang : localization.getDefaultLang());
  }
}
